import { apiRequest } from '../http.js'

export const platformApi = {
getClients: async ({ search = '', signal } = {}) => {
      const q = new URLSearchParams()
      if (search) q.set('search', search)
      const qs = q.toString()
      const data = await apiRequest(`/platform/clients${qs ? `?${qs}` : ''}`, { signal })
      return data.clients || []
    },
    getInfluencers: async ({ search = '', signal } = {}) => {
      const q = new URLSearchParams()
      if (search) q.set('search', search)
      const qs = q.toString()
      const data = await apiRequest(`/platform/influencers${qs ? `?${qs}` : ''}`, { signal })
      return data.influencers || []
    },
    getUsers: async ({ search = '', role = '', limit, signal } = {}) => {
      const q = new URLSearchParams()
      if (search) q.set('search', search)
      if (role) q.set('role', role)
      if (limit != null && limit !== '') q.set('limit', String(limit))
      const qs = q.toString()
      const data = await apiRequest(`/platform/users${qs ? `?${qs}` : ''}`, { signal })
      return data.users || []
    },
    getPeople: async ({
      search = '',
      roles = [],
      tenantIds = [],
      status = '',
      noTenant = false,
      crossTenantMismatch = false,
      limit = 500,
      offset = 0,
      signal,
    } = {}) => {
      const q = new URLSearchParams()
      if (search) q.set('search', search)
      if (roles?.length) q.set('roles', roles.join(','))
      if (tenantIds?.length) q.set('tenantIds', tenantIds.join(','))
      if (status) q.set('status', status)
      if (noTenant) q.set('noTenant', '1')
      if (crossTenantMismatch) q.set('crossTenantMismatch', '1')
      if (limit != null) q.set('limit', String(limit))
      if (offset != null) q.set('offset', String(offset))
      const qs = q.toString()
      return apiRequest(`/platform/people${qs ? `?${qs}` : ''}`, { signal })
    },
    updatePerson: async (personId, payload, options = {}) => {
      const data = await apiRequest(`/platform/people/${personId}`, {
        ...options,
        method: 'PATCH',
        body: JSON.stringify(payload),
      })
      return data.person
    },
    archivePerson: async (personId, options = {}) => {
      const data = await apiRequest(`/platform/people/${personId}/archive`, {
        ...options,
        method: 'POST',
      })
      return data.person
    },
    restorePerson: async (personId, options = {}) => {
      const data = await apiRequest(`/platform/people/${personId}/restore`, {
        ...options,
        method: 'POST',
      })
      return data.person
    },
    bulkArchivePeople: async (ids, { archived = true, ...options } = {}) => {
      return apiRequest('/platform/people/bulk-archive', {
        ...options,
        method: 'POST',
        body: JSON.stringify({ ids, archived }),
      })
    },
    getUserDeletionImpact: async (userId, options = {}) => {
      return apiRequest(`/platform/users/${userId}/deletion-impact`, options)
    },
    forcePasswordReset: async (userId, options = {}) => {
      return apiRequest(`/platform/users/${userId}/force-password-reset`, {
        ...options,
        method: 'POST',
      })
    },
    resendPersonInvite: async (personId, options = {}) => {
      return apiRequest(`/platform/people/${personId}/resend-invite`, {
        ...options,
        method: 'POST',
      })
    },
    deleteUser: async (userId, { confirmEmail, impactChecksum }) => {
      await apiRequest(`/platform/users/${userId}`, {
        method: 'DELETE',
        body: JSON.stringify({ confirmEmail: confirmEmail?.trim?.() || confirmEmail, impactChecksum }),
      })
    },
    getClientDeletionImpact: async (id, options = {}) => {
      return apiRequest(`/platform/clients/${id}/deletion-impact`, options)
    },
    deleteClient: async (id, { confirmNameOrEmail, impactChecksum, ...options } = {}) => {
      await apiRequest(`/platform/clients/${id}`, {
        ...options,
        method: 'DELETE',
        body: JSON.stringify({ confirmNameOrEmail, impactChecksum }),
      })
    },
    getInfluencerDeletionImpact: async (id, options = {}) => {
      return apiRequest(`/platform/influencers/${id}/deletion-impact`, options)
    },
    deleteInfluencerRoster: async (id, { confirmNameOrEmail, impactChecksum, ...options } = {}) => {
      await apiRequest(`/platform/influencers/${id}`, {
        ...options,
        method: 'DELETE',
        body: JSON.stringify({ confirmNameOrEmail, impactChecksum }),
      })
    },
    getHygieneIssues: async ({ category, tenantId, limit, offset, signal } = {}) => {
      const q = new URLSearchParams()
      if (category) q.set('category', category)
      if (tenantId) q.set('tenantId', tenantId)
      if (limit != null) q.set('limit', String(limit))
      if (offset != null) q.set('offset', String(offset))
      const qs = q.toString()
      return apiRequest(`/platform/hygiene/issues${qs ? `?${qs}` : ''}`, { signal })
    },
    repairUserTenantAlignment: async (userId, options = {}) => {
      return apiRequest('/platform/hygiene/repair/user-tenant-alignment', {
        ...options,
        method: 'POST',
        body: JSON.stringify({ userId }),
      })
    },
    getHygieneClientDeletionImpact: async (id, options = {}) => {
      return apiRequest(`/platform/hygiene/clients/${id}/deletion-impact`, options)
    },
    deleteHygieneClient: async (id, { confirmNameOrEmail, impactChecksum, ...options } = {}) => {
      await apiRequest(`/platform/hygiene/clients/${id}`, {
        ...options,
        method: 'DELETE',
        body: JSON.stringify({ confirmNameOrEmail, impactChecksum }),
      })
    },
    
    impersonate: async (userId) => {
      return apiRequest(`/platform/impersonate/${userId}`, { method: 'POST' })
    },
}
